import { diYu } from '../constant/common-var'

const options = {
  长期意向: {
    Y: { word: 'Y.积极看机会', color: '#f33' },
    N: { word: 'N.暂时不看机会', color: '#f93' },
    F: { word: 'F.再跟进', color: '#ccf' },
  },
  性别: ['男', '女', ''],
  婚育: ['未婚', '已婚未育', '已婚已育', '其他', ''],
  职级: {
    '1': '1.高管',
    '2': '2.部门总',
    '3': '3.部门副总/总助/团队长',
    '4': '4.部门核心骨干',
    '5': '5.新人三年以下',
    '': '--',
  },
  业绩: {
    aaa: 'aaa.领军人物',
    aa: 'aa.卓越人选',
    a: 'a.优秀人选',
    b: 'b.良好',
    c: 'c.一般',
    d: 'd.较差',
    '': '--',
  },
  平台: {
    A: 'A.大平台',
    B: 'B.中平台',
    C: 'C.小平台',
    '': '--',
  },
  地域: diYu,
  专业职级: ['ManagingPartner', 'Partner', 'MD', 'ED', 'D', 'AD', 'SVP', 'VP', 'SA', 'Asso', 'AN', ''],
  管理职级: [
    '公司总经理',
    '公司副总',
    '公司总助',
    '一级部门总',
    '二级部门总',
    '部门副总',
    '部门总助',
    '总监',
    '副总监',
    '经理',
    '主管',
    '专员',
    '',
  ],
  学历: ['中专', '大专', '本科', '硕士', '博士', '博士后', ''],
  投资风格: ['GARP型', '价值型', '成长型', '极致成长型', '综合型', ''],
  离职意愿度: {
    95: '离职动机强',
    75: '有机会会动',
    55: '观望不拒绝机会',
  },
  语言标签: ['英文-1-母语水平', '英文-2-工作语言', '英文-3-口语较弱', '粤语', '日语', '法语', '小语种'],
  职业资格: [
    '保代',
    '准保',
    '保代A类',
    '保代B类',
    '保代C类',
    '基金从业资格',
    '证券从业资格',
    'CFA',
    'CPA',
    'FRM',
    '律师执业资格',
    '法律从业资格',
    'REITs基金经理从业资格',
    '期货从业资格',
    '银行从业资格',
    'CIA（审计师）',
    'ACCA（国际注册会计师）',
    'CMA（美国注册管理会计师）',
    'CISA（信息系统审计师）',
    'CTA（税务师）',
    'SOA（北美保险精算师）',
    'CAA（保险精算师）',
  ],
  学历标签: [
    '常青藤',
    '清北交复',
    '985',
    '211',
    '海外背景',
    'QS100',
    'TIMES100',
    '理工科',
    '财务',
    '法务',
    '金融',
    '医药医疗',
    '微电子',
    '计算机',
    '中金line',
    '中信line',
    '建投line',
    '广发学历',
    '前海开源line',
  ],
  行业: app.industries || [],
  期望行业: app.industries || [],
  期望地域: diYu || [],
  领导力: ['领导力强', '领导力弱', '逆商高', '逆商低', '强资源人脉'],
  个人风格: [
    '保守',
    '稳健',
    '开拓（追求卓越）',
    '激进（狼性文化）',
    'social型',
    '学术研究型',
    '适合美元',
    '适合人民币',
    '具有创业精神',
    '情商高',
    '校友资源型',
    '政府资源型',
    '容貌风格',
  ],
  医疗科室: [
    '外科',
    '神经外科',
    '脑科学',
    '骨科',
    'ICU',
    '血管外科',
    '心内科',
    '心外科',
    '呼吸科',
    '消化科',
    '内分泌科',
    '急诊科',
    '齿科',
    '眼科',
    '康复科',
    '肾内科',
    '耳鼻喉科',
    '生殖妇产',
    '设备科',
    '影像科',
    '超声科',
    '放射科',
    '信息科',
    '妇产科',
    '肿瘤科',
    '检验科',
    '血液科',
    'LDT三方检验所',
    '药企',
    '高校',
    '皮肤科',
  ],
  业务方向: ['化工', '精细化工', '医药', '石油&天然气', '冶金/矿业', '新能源'],
  上市经验: ['主板上市', '科创板上市', '香港上市', '创业板上市', '新三板上市', '美国上市', '无'],
  业务类型: ['生产业务', '项目业务', '人民币基金', '销售和市场业务', '研发业务', '美元基金'],
  专业因素: [
    '专业能力强',
    '销售能力强',
    '研究功底扎实',
    '逻辑思维强',
    '思维散乱',
    '沟通能力强',
    '表达能力弱',
    '商业意识强',
    '执行力强',
  ],
  心态个性: [
    '心态积极正向',
    '消极负面',
    '战略思维、注重长远',
    '看重短期',
    '事业心强',
    '追求家庭工作平衡',
    '追求创新',
    '个性求稳',
    '积极进取',
    '结果导向',
  ],
  职能模块: [],
  细分职能: [],
  擅长方向: [],
  获奖经历: ['新财富', '金牛奖', '水晶球', '麒麟奖', '英华奖'],
  投资年限: ['1-3年', '3-7年', '7-10年', '10年以上'],
  '承揽-承做': ['承揽', '承做', '存续期管理'],
  期望职能: [],
  '人员背景（股）': ['四大背景', '监管背景', '政府背景', '产业背景', 'VIP', '在大平台做过', '在合资外资做过'],
  平台性质: ['美元/双币种', '人民币', '国家队', '险资', '券商直投', '战投/CVC'],
  投资阶段: ['天使轮及之前', 'PreA', 'A', 'B', 'C', 'Growth/PE', 'Pre-IPO', '一级半定增', 'Buyout'],
  人员背景: [
    {
      value: '通用',
      label: '通用',
      children: [
        {
          value: '四大背景',
          label: '四大背景',
        },
        {
          value: '产业背景',
          label: '产业背景',
        },
        {
          value: '政府背景',
          label: '政府背景',
        },
        {
          value: '监管背景',
          label: '监管背景',
        },
        {
          value: '咨询背景',
          label: '咨询背景',
        },
        {
          value: '内资背景',
          label: '内资背景',
        },
        {
          value: '外资背景',
          label: '外资背景',
        },
        {
          value: '银行背景',
          label: '银行背景',
        },
        {
          value: '券商背景',
          label: '券商背景',
        },
        {
          value: '公募背景',
          label: '公募背景',
        },
      ],
    },
    {
      value: '投行',
      label: '投行',
      children: [
        {
          value: 'VIP',
          label: 'VIP',
        },
        {
          value: '在大平台做过',
          label: '在大平台做过',
        },
        {
          value: '在合资外资做过',
          label: '在合资外资做过',
        },
      ],
    },
    {
      value: '投行港股',
      label: '投行港股',
      children: [
        {
          value: '中资行',
          label: '中资行',
        },
        {
          value: '外资行',
          label: '外资行',
        },
      ],
    },
    {
      value: '股权投资',
      label: '股权投资',
      children: [
        {
          value: '投行背景',
          label: '投行背景',
        },
        {
          value: 'FA背景',
          label: 'FA背景',
        },
        {
          value: '学科背景',
          label: '学科背景',
        },
      ],
    },
    {
      value: '二级资管',
      label: '二级资管',
      children: [
        {
          value: '公募公募',
          label: '公募公募',
        },
        {
          value: '公募专户',
          label: '公募专户',
        },
        {
          value: '券商自营',
          label: '券商自营',
        },
        {
          value: '券商资管',
          label: '券商资管',
        },
        {
          value: '保险和保险资管',
          label: '保险和保险资管',
        },
        {
          value: '银行理财子',
          label: '银行理财子',
        },
        {
          value: '私募',
          label: '私募',
        },
        {
          value: '第三方平台',
          label: '第三方平台',
        },
        {
          value: '海外平台',
          label: '海外平台',
        },
        {
          value: '信托',
          label: '信托',
        },
        {
          value: '财富公司',
          label: '财富公司',
        },
      ],
    },
    {
      value: '中后台',
      label: '中后台',
      children: [
        {
          value: 'PE股权',
          label: 'PE股权',
        },
        {
          value: '海外',
          label: '海外',
        },
        {
          value: '咨询',
          label: '咨询',
        },
        {
          value: 'IT系统公司',
          label: 'IT系统公司',
        },
        {
          value: '第三方验证机构',
          label: '第三方验证机构',
        },
        {
          value: '评级机构',
          label: '评级机构',
        },
        {
          value: '海外评级机构',
          label: '海外评级机构',
        },
        {
          value: '托管',
          label: '托管',
        },
        {
          value: '律所',
          label: '律所',
        },
        {
          value: '前台业务背景',
          label: '前台业务背景',
        },
        {
          value: '审计',
          label: '审计',
        },
        {
          value: '会计师事务所',
          label: '会计师事务所',
        },
      ],
    },
    {
      value: '品牌公关',
      label: '品牌公关',
      children: [
        {
          value: '媒体记者出身',
          label: '媒体记者出身',
        },
        {
          value: '4A广告公司',
          label: '4A广告公司',
        },
        {
          value: '互联网',
          label: '互联网',
        },
        {
          value: '科技',
          label: '科技',
        },
        {
          value: '金融(公募基金）',
          label: '金融(公募基金）',
        },
        {
          value: '金融(私募基金）',
          label: '金融(私募基金）',
        },
        {
          value: '金融（券商）',
          label: '金融（券商）',
        },
      ],
    },
    {
      value: 'HR人力',
      label: 'HR人力',
      children: [
        {
          value: 'PEVC背景',
          label: 'PEVC背景',
        },
        {
          value: '猎头背景',
          label: '猎头背景',
        },
        {
          value: '互联网背景',
          label: '互联网背景',
        },
        {
          value: '分支机构背景',
          label: '分支机构背景',
        },
        {
          value: '医药医疗背景',
          label: '医药医疗背景',
        },
        {
          value: '筹备期经验（从0到1）',
          label: '筹备期经验（从0到1）',
        },
        {
          value: '老板心腹',
          label: '老板心腹',
        },
      ],
    },
  ],
  特殊能力: ['募资资源', '投后管理', '有退出经验', 'sourcing项目'],
  是否流片: { 是: '是', 否: '否' },
  是否量产: { 是: '是', 否: '否' },
  投资标的: ['公募FOF', '私募FOF'],
  公开业绩: ['有', '无'],
  人才来源: [
    '公募公募',
    '公募专户',
    '券商自营',
    '券商资管',
    '保险和保险资管',
    '银行',
    '银行理财子',
    '私募',
    '第三方平台',
    '海外平台',
    '信托',
    '财富公司',
  ],
  医疗背景: ['内资', '外资'],
  转换诉求: ['一级', '卖方', '买方-公募', '买方-保险', '买方-私募', '买方-券商资管', '上市公司董秘'],
  港股背景: ['中资行', '外资行'],
  意向平台: ['国企', '民企', '合资外资', '大平台', '中大型平台', '市场化激励平台'],
  人选背景: [
    '媒体记者出身',
    '4A广告公司',
    '互联网',
    '科技',
    '金融(公募基金）',
    '金融(私募基金）',
    '金融（券商）',
    '外资',
  ],
  REITs任职情况: ['在任', '拟任', '未定'],
  中后台背景: [
    '四大背景',
    '券商背景',
    '公募背景',
    'PE股权',
    '监管背景',
    '外资',
    '海外',
    '咨询',
    'IT系统公司',
    '第三方验证机构',
    '评级机构',
    '海外评级机构',
    '托管',
    '律所',
    '前台业务背景',
    '审计',
    '银行',
    '会计师事务所',
  ],
  HR背景: [
    '券商背景',
    '公募背景',
    'PEVC背景',
    '猎头背景',
    '咨询背景',
    '外资背景',
    '互联网背景',
    '分支机构背景',
    '医药医疗背景',
    '筹备期经验（从0到1）',
    '老板心腹',
  ],
  公司类型: [
    '国企/央企',
    '民营企业',
    '合资公司',
    '跨国企业',
    '上市公司',
    '非上市公司',
    '集团/控股公司',
    '海外工作',
    '自主创业',
  ],
  会计准则及证书: [
    '中国会计准则',
    '国际会计准则（IFRS）',
    '美国会计准则（US GAAP）',
    '注册会计师',
    '管理会计师',
    '董秘资格证',
    '证券从业资格',
    '基金从业资格',
    '无',
  ],
  项目及其他技能: [
    '财务系统上线',
    'Oracle系统',
    'SAP系统',
    '新公司设立（0-1）',
    '基金设立',
    '战略',
    '收购并购',
    '定价',
    '财务顾问',
    '无',
  ],
  金融业务方向: ['资管', '投行', '专户', '公募', '自营', '财富管理', '并购'],
  技术方向: ['抗体', '小核酸', '细胞治疗', '基因治疗', '疫苗'],
  治疗领域: [
    '肝病',
    'CNS',
    '眼科',
    '罕见病',
    '抗感染',
    '心血管',
    '内分泌/糖尿病',
    '肾病',
    '妇科/生殖',
    '儿科',
    '消化',
    '呼吸',
    '骨科',
  ],
  技术赛道: ['小分子', '抗体', 'ADC', '小核酸', 'mRNA', '细胞治疗', '基因治疗', '溶瘤病毒'],
  实体瘤: [
    '肺癌',
    '头颈癌',
    '黑色素瘤',
    '泌尿肿瘤',
    '肾癌',
    '妇科肿瘤',
    '乳腺癌',
    '卵巢癌',
    '消化道肿瘤',
    '胃癌',
    '肠癌',
    '肝癌',
    '胰腺癌',
  ],
  医药程序员: ['SASS程序员', '数据库程序员', '统计程序员'],
}
const fields = {
  人选期望: {
    期望行业: {
      label: '期望行业',
      width: '49%',
      type: 'multSelect',
      options: [],
    },
    期望地域: {
      label: '期望地域',
      width: '49%',
      type: 'createSelect',
      options: diYu,
    },
    期望固薪: {
      label: '期望固薪',
      width: '49%',
    },
    期望奖金: {
      label: '期望奖金',
      width: '49%',
    },
  },
  更多联系方式: {
    座机: {
      label: '座机',
      width: '49%',
    },
    邮箱: {
      label: '邮箱',
      width: '49%',
    },
    微信: {
      label: '微信',
      width: '49%',
    },
    其他: {
      label: '其他',
      width: '49%',
    },
  },
  教育经历: {
    本科院校: {
      label: '本科院校',
      width: '49%',
    },
    硕士院校: {
      label: '硕士院校',
      width: '49%',
    },
  },
}
const viewItems = {
  其他联系方式: [
    // {
    //   label: '邮箱',
    //   prop: '邮箱',
    // },
    {
      label: '座机',
      prop: '座机',
    },
  ],
  阿尔法人才画像: [
    {
      label: '职能模块',
      prop: '职能模块',
      type: 'multSelect',
      required: true,
    },
    {
      label: '细分职能',
      prop: '细分职能',
      type: 'multSelect',
      required: true,
    },
    {
      label: '擅长方向',
      prop: '擅长方向',
      type: 'multSelect',
      required: true,
    },
    {
      label: '行业',
      prop: '行业',
      type: 'select',
      width: '34%',
      required: true,
    },
    {
      label: '职级',
      prop: '职级',
      type: 'select',
      width: '33%',
      required: true,
    },
    {
      label: '业绩',
      prop: '业绩',
      type: 'select',
      width: '33%',
      required: true,
    },
  ],
  人选期望: [
    {
      label: '期望行业',
      prop: '期望行业',
      width: '50%',
      type: 'multSelect',
    },
    {
      label: '期望地域',
      prop: '期望地域',
      width: '50%',
      type: 'multSelect',
    },
    {
      label: '期望固薪',
      prop: '期望固薪',
      width: '50%',
    },
    {
      label: '期望奖金',
      prop: '期望奖金',
      width: '50%',
    },
    {
      label: '期望职能',
      prop: '期望职能',
      type: 'multSelect',
      width: '50%',
    },
  ],
}
const itemOrderObj = {
  姓名: {
    label: '姓名',
    prop: '姓名',
  },
  英文名: {
    label: '英文名',
    prop: '英文名',
  },
  长期意向: {
    label: '长期意向',
    prop: '长期意向',
    type: 'color',
  },
  手机: {
    label: '手机',
    prop: '手机',
    subscribe: '手机（及更多联系方式）',
  },
  微信: {
    label: '微信',
    prop: '微信',
  },
  离职预测: {
    label: '离职预测',
  },
  公司: {
    label: '公司',
    prop: '公司',
  },
  目前职位: {
    label: '目前职位',
    prop: '目前职位',
  },
  简历打分: {
    label: '简历打分',
  },
  部门: {
    label: '部门',
    prop: '部门',
  },
  组别: {
    label: '组别',
    prop: '组别',
  },
  人选口碑: {
    label: '人选口碑',
  },
  学历: {
    label: '学历',
    prop: '学历',
  },
  出生年月: {
    label: '出生年月',
    prop: '出生年月',
  },
  婚育: {
    label: '婚育',
    prop: '婚育',
    type: 'select',
  },
  籍贯: {
    label: '籍贯',
    prop: '籍贯',
  },
  从业起始年: {
    label: '从业起始年',
    prop: '从业起始年',
    labelWidth: '70px',
  },
  性别: {
    label: '性别',
    prop: '性别',
    type: 'select',
  },
  专业职级: {
    label: '专业职级',
    prop: '专业职级',
    type: 'select',
  },
  管理职级: {
    label: '管理职级',
    prop: '管理职级',
    type: 'select',
  },
  邮箱: {
    label: '邮箱',
    prop: '邮箱',
  },
  个性标签: {
    label: '个性标签',
    prop: '个性标签',
    size: 'full',
  },
  简介: {
    label: '简介',
    prop: '简介',
    type: 'textarea',
    size: 'full',
  },
  薪酬: {
    label: '薪酬',
    subscribe: '薪酬填写&市场参考薪酬',
    size: 'full',
  },
  阿尔法人才画像: {
    label: '阿尔法人才画像',
    subscribe: '阿尔法人才画像（职能模块、细分职能、擅长方向、职级、业绩、行业、职能特殊标签）',
    size: 'full',
  },
  平台: {
    label: '平台',
    prop: '平台',
    type: 'select',
  },
  地域: {
    label: '地域',
    prop: '地域',
    type: 'multSelect',
  },
  投资风格: {
    label: '投资风格',
    prop: '投资风格',
    type: 'select',
  },

  // 平台性质: {
  //   label: '平台性质',
  //   prop: '平台性质',
  //   // labelWidth: '70px',
  //   type: 'multSelect',
  //   // size: 'full',
  // },
  // 投资阶段: {
  //   label: '投资阶段',
  //   prop: '投资阶段',
  //   type: 'multSelect',
  //   // size: 'full',
  // },
  人员背景: {
    label: '人员背景',
    prop: '人员背景',
    type: 'cascader',
    size: 'full',
  },
  // 特殊能力: {
  //   label: '特殊能力',
  //   prop: '特殊能力',
  //   type: 'multSelect',
  //   // size: 'full',
  // },
  语言标签: {
    label: '语言标签',
    prop: '语言标签',
    type: 'multSelect',
    size: 'full',
  },
  职业资格: {
    label: '职业资格',
    prop: '职业资格',
    type: 'multSelect',
    size: 'full',
  },
  获奖经历: {
    label: '获奖经历',
    prop: '获奖经历',
    type: 'multSelect',
    size: 'full',
  },
  学历标签: {
    label: '学历标签',
    prop: '学历标签',
    type: 'multSelect',
    size: 'full',
  },
  投资年限: {
    label: '投资年限',
    prop: '投资年限',
    type: 'select',
    size: 'full',
  },
  // 期望职能: {
  //   label: '期望职能',
  //   prop: '期望职能',
  //   type: 'multSelect',
  //   size: 'full',
  // },
  // '承揽-承做': {
  //   label: '承揽-承做',
  //   prop: '承揽-承做',
  //   type: 'multSelect',
  //   labelWidth: '80px',
  // },
  // '人员背景（股）': {
  //   label: '人员背景（股）',
  //   prop: '人员背景（股）',
  //   type: 'multSelect',
  //   labelWidth: '80px',
  // },
  // 人才来源: {
  //   label: '人才来源',
  //   prop: '人才来源',
  //   type: 'multSelect',
  // },
  // 公开业绩: {
  //   label: '公开业绩',
  //   prop: '公开业绩',
  //   type: 'multSelect',
  // },
  // 投资标的: {
  //   label: '投资标的',
  //   prop: '投资标的',
  //   type: 'multSelect',
  // },
  // 医疗背景: {
  //   label: '医疗背景',
  //   prop: '医疗背景',
  //   type: 'multSelect',
  // },
  // 医疗科室: {
  //   label: '医疗科室',
  //   prop: '医疗科室',
  //   type: 'multSelect',
  // },
  // 转换诉求: {
  //   label: '转换诉求',
  //   prop: '转换诉求',
  //   type: 'multSelect',
  // },
  // 港股背景: {
  //   label: '港股背景',
  //   prop: '港股背景',
  //   type: 'multSelect',
  // },
  // 意向平台: {
  //   label: '意向平台',
  //   prop: '意向平台',
  //   type: 'multSelect',
  // },
  // 人选背景: {
  //   label: '人选背景',
  //   prop: '人选背景',
  //   type: 'multSelect',
  // },
  // REITs任职情况: {
  //   label: 'REITs任职情况',
  //   prop: 'REITs任职情况',
  //   type: 'multSelect',
  //   labelWidth: '100px',
  // },
  // 中后台背景: {
  //   label: '中后台背景',
  //   prop: '中后台背景',
  //   type: 'multSelect',
  //   labelWidth: '80px',
  // },
  // HR背景: {
  //   label: 'HR背景',
  //   prop: 'HR背景',
  //   type: 'multSelect',
  // },
  // 是否量产: {
  //   label: '是否量产',
  //   prop: '是否量产',
  //   type: 'select',
  // },
  // 是否流片: {
  //   label: '是否流片',
  //   prop: '是否流片',
  //   type: 'select',
  // },
  教育经历: {
    label: '教育经历',
    size: 'full',
  },
  工作经历: {
    label: '工作经历',
    size: 'full',
  },
  项目经历: {
    label: '项目经历',
    size: 'full',
  },
  人选期望: {
    label: '人选期望',
    subscribe: '人选期望/诉求&动机',
    size: 'full',
  },
  管理基金: {
    label: '管理基金',
    size: 'full',
  },
  保荐项目: {
    label: '保荐项目',
    size: 'full',
  },
  投资案例: {
    label: '投资案例',
    size: 'full',
  },
  领导力: {
    label: '领导力',
    prop: '领导力',
    type: 'checkbox',
    size: 'full',
  },
  个人风格: {
    label: '个人风格',
    prop: '个人风格',
    type: 'checkbox',
    size: 'full',
  },
  专业因素: {
    label: '专业因素',
    prop: '专业因素',
    type: 'checkbox',
    size: 'full',
  },
  心态个性: {
    label: '心态个性',
    prop: '心态个性',
    type: 'checkbox',
    size: 'full',
  },
}
export { options, fields, viewItems, itemOrderObj }
